import { render, staticRenderFns } from "./PointManageLists.vue?vue&type=template&id=5c4e5fd2&"
import script from "./PointManageLists.vue?vue&type=script&lang=js&"
export * from "./PointManageLists.vue?vue&type=script&lang=js&"
import style0 from "./PointManageLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports